import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from '../../store/userSlice';
import { UserMenu } from './UserMenu';

const UserMenuContainer = (props) => {
    const dispatch = useDispatch();
    const { fullName } = useSelector(state => state.user.grants);

    useEffect(() => {
        if (!fullName) {
            dispatch(getCurrentUser());
        }
    }, [ fullName ]);

    let name, lastname;
    if (typeof fullName === "string") {
        name = fullName.split(" ")[0];
        lastname = fullName.split(" ")[1];
    };

    return(
        <UserMenu
            name={name}
            lastname={lastname}
        />
    )
};

export { UserMenuContainer };
